// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ae6a801","732":"eb865a7d"}[chunkId] + ".chunk.js";
};